import { Directive, ElementRef, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import debounce from 'lodash/debounce';

@Directive({
    selector: '[appEventLogObserver]',
    standalone: false
})
export class LogObserverDirective implements AfterViewInit, OnDestroy {
  @Output() isVisible: EventEmitter<any> = new EventEmitter();

  private observer: IntersectionObserver;
  private latestVisibleTarget: Element | null = null;

  // 디바운스: 마지막 보인 요소 emit (전체 100ms간 변화 없을 때)
  private emitAfterScrollStop = debounce(() => {
    if (this.latestVisibleTarget) {
      this.isVisible.emit(this.latestVisibleTarget);
      this.latestVisibleTarget = null;
    }
  }, 300);

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    requestAnimationFrame(() => this.snapshotObserver());
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    this.emitAfterScrollStop.cancel();
  }

  private snapshotObserver() {
    const observerOptions = {
      root: document.querySelector('.setting-router'),
      threshold: 0.5
    };

    this.observer = new IntersectionObserver((entries) => {
      const visibleEntry = entries.find(entry => entry.isIntersecting);
      if (visibleEntry) {
        this.latestVisibleTarget = visibleEntry.target as Element;
        this.emitAfterScrollStop(); // 디바운스된 함수 (target은 내부 상태로 저장)
      }
    }, observerOptions);

    this.observer.observe(this.el.nativeElement);
  }
}
